import { useQuery } from "@tanstack/react-query";
import { fetch } from "./fetch";
import { Operator } from "../app/Operators/model";

const getOperatorData = async (operatorId: string) => {
  return fetch<Operator>(`/api/operators/operator/${operatorId}`);
};

export const useOperatorDataQuery = (operatorId: string) => {
  return useQuery({
    queryKey: ["operator", operatorId],
    queryFn: () => getOperatorData(operatorId),
    enabled: !!operatorId,
  });
};
